import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TextInputComponent } from '../text-input/text-input.component';

@Component({
  selector: 'chip-input',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true,
    },
  ],
  templateUrl: './chip-input.component.html',
  styleUrl: './chip-input.component.scss'
})
export class ChipInputComponent {
  @Input() label: string;
  @Output() valueChange = new EventEmitter<string[]>();
  @Input() chips: string[] = [];
  inputValue: string = '';

  addChip(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();

    if (event.key === ' ' && value) {
      if (!this.chips.includes(value)) {
        this.chips.push(value);
        this.valueChange.emit(this.chips);
      }
      this.inputValue = '';
      event.preventDefault();
    }
  }

  removeChip(index: number): void {
    this.chips.splice(index, 1);
  }
}
